export default {
  currencies: {
    DOP: 'Dominican Republic',
    USD: 'United States',
    COP: 'Colombia',
    MXN: 'Mexico',
    ARS: 'Argentina',
    CLP: 'Chile',
    PEN: 'Peru',
    BSD: 'Bahamas',
    ANG: 'Curacao',
  },
  countries: {
    AR: 'Argentina',
    BS: 'Bahamas',
    CL: 'Chile',
    CO: 'Colombia',
    CW: 'Curacao',
    DO: 'Dominican Republic',
    MX: 'Mexico',
    PE: 'Peru',
  },
  countrySelect: {
    placeholder: 'Choose a country',
  },
  app: {
    title: 'StreetLoans',
    logout: 'Log out',
    language: 'Language',
    toggleTheme: 'Switch theme',
    theme: {
      toDark: 'Switch to dark theme',
      toLight: 'Switch to light theme',
    },
    toggleMenu: 'Menu',
    mainNavigation: 'Main navigation',
    collapseMenu: 'Collapse menu',
    userMenu: 'Account',
  },
  menu: {
    commissions: 'Commissions',
    groups: {
      home: 'Home',
      applications: 'Applications',
      loans: 'Loans',
      finance: 'Finance',
      more: 'More',
    },
    dashboard: 'Dashboard',
    customers: 'Customers',
    loans: 'Loans',
    collections: 'To collect',
    myPayments: 'My collections',
    loanRequests: 'Requests',
    myLoanRequests: 'My requests',
    loanTables: 'Tables',
    accounting: 'Finances',
    routes: 'Routes',
    members: 'Team',
    roles: 'Roles',
    import: 'Import book',
    paymentReview: 'Review queue',
    loanCalculator: 'Calculator',
    settings: 'Settings',
    cashClose: 'Cash close',
    finance: {
      overview: 'Position & result',
      chart: 'Chart of accounts',
      transactions: 'Transactions',
      expenses: 'Expenses',
      impairment: 'Impairment',
      periodClose: 'Period close',
      postingRules: 'Posting rules',
    },
  },
  platform: {
    badge: 'Platform',
    menu: {
      overview: 'Overview',
      plans: 'Plans',
      tenants: 'Customers',
      accounts: 'Accounts',
    },
    accounts: {
      title: 'Account audit',
      subtitle: 'Every web account, including hidden and inconsistent records.',
      email: 'Email',
      state: 'State',
      memberships: 'Memberships',
      active: 'Active',
      inactive: 'Inactive',
      allStatuses: 'All statuses',
      allTypes: 'All types',
      orphan: 'Orphan',
      shared: 'Shared',
      inconsistent: 'Inconsistent',
      platformAdmin: 'Platform admin',
      member: 'Member',
      noRoles: 'No roles',
      missingRole: 'Missing role',
      empty: 'No accounts match these filters.',
      cleanup: 'Delete orphan',
      cleanupConfirm: 'Delete orphan account {email}? This cannot be undone.',
      cleanupSucceeded: 'The orphan account was deleted.',
      cleanupFailed: 'The orphan account could not be deleted.',
    },
    tenants: {
      title: 'Customers',
      subtitle: 'The businesses lending on StreetLoans.',
      create: 'New customer',
      createTitle: 'New customer',
      createFailed: 'The customer could not be created.',
      created: 'Created. A temporary password is on its way to {email}.',
      edit: 'Edit',
      editTitle: 'Edit business',
      updated: 'The business was saved.',
      updateFailed: 'The business could not be saved.',
      emailFailed:
        'The business was created, but the temporary-password email failed. Provision a new one before telling them.',
      emptyList: 'No customers yet.',
      emptyHint: 'Creating one sets up the business and emails its owner a temporary password.',
      name: 'Business',
      owner: 'Owner',
      ownerEmail: 'Owner email',
      ownerEmailHint:
        'They receive a temporary password by email and choose their own on first sign-in.',
      passwordPending: 'Temporary password sent to {email}',
      ceiling: 'Ceiling',
      ceilingFromPlan: 'From the plan',
      editCeiling: 'Loan ceiling',
      ceilingHint:
        'Live loans this business may carry, over what its plan allows. Clear it to fall back to the plan.',
      clearCeiling: 'Clear its own ceiling',
      ceilingFailed: 'The ceiling could not be changed.',
      suspend: 'Suspend',
      reactivate: 'Reactivate',
      suspendTitle: 'Suspend business',
      suspendWarning:
        'Nobody at {name} will be able to sign in — not the owner, not their collectors — until you reactivate it. Nothing is deleted: the loan book, the ledger and the team stay where they are.',
      suspendReason: 'Reason',
      suspendReasonHint: 'Kept in the audit trail for whoever reads it later. Optional, but it helps.',
      activeFailed: 'The business status could not be changed.',
      noOwner: 'No owner yet',
      plan: 'Plan',
      country: 'Country',
      countryHint: 'Decides the gota a gota tables the business starts with.',
      status: 'Status',
      createdAt: 'Created',
      inactive: 'Inactive',
      noSubscription: 'No subscription',
      noSellablePlans: 'No plan is on sale, so nobody can be created. Put one on the shelf first.',
      editOwner: 'Edit owner email',
      ownerUpdated: 'The owner email was saved.',
      ownerFailed: 'The owner email could not be saved.',
      changePlan: 'Change plan',
      planUpdated: 'The subscription plan was changed.',
      planFailed: 'The subscription plan could not be changed.',
      planWarning: 'Changing {name} to a different plan can change what the business can use.',
      extendSubscription: 'Extend subscription',
      extensionDays: 'Days to extend',
      extensionUpdated: 'The subscription was extended.',
      extensionFailed: 'The subscription could not be extended.',
      resendAccess: 'Resend owner access',
      resendWarning: 'Send a new temporary password to the owner of {name}. The old temporary password will no longer work.',
      resendDelivered: 'A new temporary password was sent to the owner.',
      audit: 'Audit',
      users: 'Users',
      memberships: 'Memberships',
      emptyTenant: 'Empty tenant',
      customers: 'Customers',
      loans: 'Loans',
      delete: 'Delete tenant',
      deleteTitle: 'Delete tenant',
      deleteWarning: 'Delete {name} permanently?',
      deleteConfirmationWarning: 'This action permanently deletes all of the business’s data and cannot be undone. Type delete to confirm.',
      deleteConfirmationLabel: 'Type delete to confirm',
      deleted: 'The tenant was deleted.',
      deleteFailed: 'The tenant could not be deleted.',
      resendFailed: 'The access was updated, but the temporary-password email was not delivered.',
      statuses: {
        Trialing: 'Trial',
        Active: 'Active',
        PastDue: 'Past due',
        Canceled: 'Canceled',
      },
    },
    plans: {
      title: 'Plans',
      subtitle: 'What the platform sells, and what each plan unlocks.',
      create: 'New plan',
      createTitle: 'New plan',
      editTitle: 'Edit plan',
      edit: 'Edit',
      emptyList: 'Nothing on the shelf yet.',
      emptyHint: 'A plan is what a business is sold. Create one before adding customers.',
      basicInfo: 'Plan',
      name: 'Name',
      code: 'Code',
      codeHint: 'Lowercase letters, digits and dashes. It cannot be changed later.',
      codeLocked: 'The code is what every subscription points at, so it never changes. Rename the plan instead.',
      monthlyPrice: 'Monthly price',
      loanLimit: 'Loan ceiling',
      loanLimitHint: 'Live loans a business on this plan may carry. Leave empty for unlimited. At the ceiling only disbursing stops — payments and requests keep working.',
      unlimited: 'Unlimited',
      capabilitiesLabel: 'Capabilities',
      noCapabilities: 'None',
      tenants: 'Businesses',
      retired: 'Retired',
      availableHint: 'On sale. A retired plan keeps serving the businesses already on it.',
      saved: 'Plan saved.',
      saveFailed: 'The plan could not be saved.',
      revokeWarning:
        'Businesses on this plan: {count}. Saving takes this away from them: {capabilities}.',
      retireWarning:
        'Businesses on this plan: {count}. They keep it — retiring only takes the plan off the shelf.',
      capabilities: {
        collectors: 'Collectors',
        routes: 'Collection routes',
        accounting: 'Finances',
      },
    },
    overview: {
      title: 'Platform administration',
      carries:
        'No businesses on the platform yet. | {count} business on the platform. | {count} businesses on the platform.',
      onTrial: 'none on trial | {count} on trial | {count} on trial',
      needsYou: 'Needs you',
      stats: {
        revenue: 'Monthly revenue',
        revenueNote: 'From {count} paying businesses.',
        businesses: 'Businesses',
        newThisMonth: '{count} new this month.',
        trialing: 'On trial',
        endingSoon: '{count} end this week — call them.',
        noneEndingSoon: 'None end this week.',
        attention: 'Need attention',
        attentionNote: 'No owner inside, or suspended.',
      },
      allClear: 'Nothing waiting — every business has an owner signed in.',
      awaitingOwner: 'temporary password sent to {email}, not claimed yet',
      suspended: 'suspended',
      trialEnds: 'the trial ends in {days} days',
      shelf: 'On the shelf',
      allPlans: 'All plans',
      noPlans: 'Nothing on the shelf yet, so nobody can be sold a plan.',
      boundary:
        'Plans, prices and businesses only. It cannot open a lender’s customers, loans or payments, and it cannot sign in as one of their users.',
    },
  },
  team: {
    isPromoter: 'Brings business in (promoter)',
    promoterRate: 'Their commission',
    promoterRateHint: "Points of the loan's rate. Left empty, the business figure applies.",
    title: 'Staff',
    hint: 'Who works here and what each of them may do. An employee can hold more than one role.',
    hire: 'Register employee',
    person: 'Person',
    firstName: 'First name',
    lastName: 'Last name',
    idNumber: 'National ID',
    idNumberPlaceholder: '000-0000000-0',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    hiredOn: 'Start date',
    roles: 'Roles',
    rolesPlaceholder: 'Pick one or more',
    roleRequired: 'Pick at least one role. An employee with no role signs in fine and can do nothing.',
    status: 'Status',
    active: 'Active',
    revoked: 'Revoked',
    change: 'Change',
    stillWorksHere: 'Still works here',
    handover: 'Account created for {email}. Hand them this password now:',
    handoverHint: 'It is not emailed. It is shown once, and the employee changes it on first sign-in.',
    updated: 'Employee updated.',
    updateFailed: 'The employee could not be updated.',
    hireFailed: 'The employee could not be registered.',
    remove: 'Remove',
    emailEditHint: 'Correct a mistyped address here. They will sign in with the new one.',
    loadFailed: 'The staff list could not be loaded.',
  },
  api: {
    team: {
      employeeHired: 'Employee registered. Hand them the temporary password.',
      profileUpdated: 'Your profile was updated.',
      photoUpdated: 'Your photo was updated.',
      photoRemoved: 'Your photo was removed.',
      roleRequired: 'Pick at least one role. An employee with no role can do nothing.',
      roleNotYours: 'That role does not belong to this business.',
      emailTaken: 'An account with that email already exists.',
      idNumberTaken: 'An employee with that national ID already exists.',
      detailsIncomplete: 'Employee details are incomplete: first name, last name, national ID and phone are required.',
      employeeUpdated: 'Employee updated.',
      unknownPermission: '“{permission}” is not a permission.',
      employeeNotFound: 'That employee does not belong to this business.',
      cannotRevokeYourself: 'You cannot revoke your own access.',
      employeeRemoved: 'The employee was removed.',
      employeeHasSignedIn: 'They have signed in, so they have history. Deactivate them instead of removing them.',
      wouldLeaveNoAdmin: 'The business would be left with nobody who can manage users.',
    },
    migration: {
      backupRejected: 'The backup carries a corrupt fact: {reason}',
      nothingToImport: 'The backup contains no customers or loans to import.',
      bookNotEmpty: 'This business already has data. An import only runs into an empty book.',
      paymentWithoutInstallment: 'A payment points at an installment that is not in the backup.',
      loanWithoutCustomer: 'Loan “{code}” points at a customer that is not in the backup.',
      installmentWithoutLoan: 'Installment #{number} points at a loan that is not in the backup.',
    },
    platform: {
      tenantNameRequired: 'The business needs a name.',
      ownerEmailInvalid: 'That owner email address is not valid.',
      noStartingTables: 'There are no starting tables for “{country}”. Known: {known}.',
      planCodeUnknown: 'There is no plan with the code “{code}”.',
      planRetired: 'The plan “{name}” is retired and cannot be sold.',
      emailHasAccount: '{email} already has an account.',
      tenantCreatedFor: '“{name}” created. A temporary password is on its way to {email}.',
      tenantCreatedEmailFailedFor: '“{name}” created, but the temporary-password email failed. Provision a new one before telling them.',
      ceilingSet: 'This business may now carry {ceiling} live loans.',
      ceilingCleared: 'The plan\'s own limit applies again.',
      tenantAlreadyActive: 'That business is already active.',
      tenantAlreadySuspended: 'That business is already suspended.',
      planCodeRequired: 'A plan needs a code.',
      planNameRequired: 'A plan needs a name.',
      planPriceNotNegative: 'A plan cannot cost less than nothing.',
      planLimitZero: 'A limit of zero would sell a plan that can never lend; leave it empty for unlimited.',
      planGone: 'That plan no longer exists.',
      ceilingAtLeastOne: 'A ceiling has to be at least one loan. Clear it to fall back to the plan.',
      noSubscriptionForCeiling: 'That business has no subscription to set a ceiling on.',
      tenantGone: 'That business does not exist.',
      cannotSuspendPlatform: 'The platform\'s own tenant cannot be suspended.',
      planCodeShape: '“{code}” is not a usable plan code: use up to {max} lowercase letters, digits and dashes.',
      unknownCapability: '“{capability}” is not a capability.',
      planCodeTaken: 'A plan with the code “{code}” already exists.',
      planCreated: 'Plan “{name}” created.',
      planSaved: 'Plan “{name}” saved.',
      tenantActiveAgain: '“{name}” is active again.',
      tenantSuspended: '“{name}” is suspended. Nobody under it can sign in.',
      countryNotSupported: 'That country is not supported.',
      notAPlatformAdmin: 'Only a platform administrator may do this.',
      tenantUpdated: 'The business was saved.',
      tenantPlanChanged: 'The subscription plan was changed.',
      tenantPeriodExtended: 'The subscription period was extended.',
      extensionDaysRequired: 'Enter the number of days to extend the subscription.',
      subscriptionCannotExtend: 'This subscription cannot be extended.',
      ownerAmbiguous: 'Multiple owners were found for this business.',
      ownerEmailUpdated: 'The owner email was updated.',
      ownerAccessResent: 'New temporary access was sent to the owner.',
      ownerAccessResendEmailFailed: 'The access was updated, but the temporary-password email could not be delivered.',
      tenantDeleted: 'The business was deleted.',
      tenantHasFinancialData: 'This business cannot be deleted because it has financial data.',
      tenantDeleteConfirmationRequired: 'Type eliminar to confirm deletion of this business and its customer and loan data.',
      cannotDeletePlatform: 'The platform business cannot be deleted.',
      accountGone: 'That account no longer exists.',
      accountHasMemberships: 'This account still has memberships and cannot be deleted.',
      orphanAccountDeleted: 'The orphan account was deleted.',
    },
    auth: {
      recoveryHashNotUpdated: 'The recovery code could not be updated: {reason}',
      temporaryPasswordExpired: 'This temporary password has expired. Ask the console for a new one.',
      mustChangePassword: 'You must change your temporary password before doing anything else.',
      currentPasswordWrong: 'The current password is incorrect.',
      passwordTooWeak: 'The new password does not meet the security requirements.',
      accountNotCreated: 'The account could not be created: {reason}',
      ownerRegistered: 'Registered. Enter the code we just sent you.',
      ownerRegisteredOtpFailed: 'Registered, but the code could not be delivered — ask for it again.',
      newPasswordRequired: 'The new password is required.',
      newPasswordMustDiffer: 'The new password must be different from the current one.',
      accountNotFound: 'Account not found.',
      passwordUpdated: 'Password updated. Sign in again on your other devices.',
      fingerprintRequired: 'Device fingerprint is required.',
      invalidCredentials: 'Invalid credentials.',
      temporarilyLocked: 'Too many failed attempts. The account unlocks itself in {minutes} minutes — your password still works, there is no need to change it.',
      emailNotVerified: 'Email not verified. Enter the code we sent to your inbox to activate your account.',
      accessNoLongerActive: 'Your access to this business is no longer active.',
      loginSuccess: 'Login success.',
      ok: 'OK',
      noActiveMembership: 'No active membership for this tenant.',
      refreshTokenInvalid: 'Refresh token invalid.',
      sessionSignedInElsewhere: 'This account signed in from another browser. Only one web session can be open at a time.',
      sessionSignedOut: 'The session was closed. Sign in again.',
      sessionExpired: 'The session ran out. Sign in again.',
      sessionPasswordChanged: 'This account changed its password, so open sessions were closed.',
      sessionRevokedByAdmin: 'An administrator closed this session.',
      ownerNotFound: 'Owner not found.',
      tokenRefreshed: 'Token refreshed.',
      emailAlreadyRegistered: 'Email already registered.',
      recoveryHashRequired: 'Recovery code hash is required.',
      recoveryHashUpdated: 'Recovery hash updated.',
      passwordResetRequested: 'If the account exists, we sent a link.',
      passwordResetInvalid: 'That link is not valid or has expired. Ask for a new one.',
      passwordReset: 'Your password has been changed.',
      otpChallengeInvalid: 'OTP challenge invalid or expired.',
      otpCodeInvalid: 'Invalid OTP code.',
      contactVerified: 'Contact verified.',
    },
    memberships: {
      accountNotCreated: 'The account could not be created: {reason}',
      ok: 'OK',
      namesRequired: 'First and last name are required.',
      roleNotFound: 'Role not found.',
      memberNotFound: 'Member not found.',
      cannotRemoveLastAdmin: 'Cannot remove users.manage from the last active admin.',
      emailRequired: 'A valid email is required.',
      passwordRequired: 'Password is required.',
      emailTaken: 'That email is already registered.',
      employeeCreated: 'Employee created.',
      cannotDeactivateLastAdmin: 'Cannot deactivate the last active admin.',
      memberDeactivated: 'Member deactivated. Their access ends with this request.',
      permissionCoveredByRole: 'Permission is already covered by the member\'s role.',
      permissionAlreadyGranted: 'Permission was already granted.',
      memberReactivated: 'Member reactivated.',
      noGrantToRevoke: 'No extra grant to revoke for that permission.',
      roleAssigned: 'Assigned the role “{role}”.',
      unknownPermission: '“{permission}” is not a permission.',
      permissionGranted: 'Granted “{permission}”.',
      permissionRevoked: 'Revoked “{permission}”.',
    },
    roles: {
      nameRequired: 'Role name is required.',
      notFound: 'Role not found.',
      systemCannotDelete: 'System roles cannot be deleted.',
      inUse: 'Role is assigned to one or more members. Reassign them first.',
      adminLocked: 'The Admin role is locked and cannot be edited.',
      wouldLeaveNoAdmin: 'Cannot remove user management from this role: it would leave the tenant with no administrator.',
      unknownPermission: '“{permission}” is not a permission.',
      nameTaken: 'A role named “{name}” already exists.',
      created: 'Role “{name}” created.',
      deleted: 'Role “{name}” deleted.',
      updated: 'Role “{name}” updated.',
    },
    payments: {
      waivePermissionNeeded: 'Discounts need the payments.waive permission; record the full amount owed or ask the office to grant it.',
      subscriptionInactive: 'Your subscription is inactive; only payments collected before it lapsed can be recorded.',
      installmentAlreadyPaid: 'Installment is already paid.',
      exceedsBalance: 'Payment exceeds the outstanding balance plus pending late fees.',
      loanCancelled: 'Loan {code} was cancelled; nothing can be collected on it.',
      fundingSourceNotOurs: 'That funding source is not one this business can collect into.',
      noFundingSource: 'This business has no funding source to collect into.',
      sayWhichFundingSource: 'Say which funding source this money went into.',
      reviewRejected: 'Rejected: {reason}',
      noActiveMembership: 'Your account has no active access to this business.',
      receiptCodeShape: 'The receipt code is eight letters and digits.',
      receiptDateRequired: 'The receipt\'s date is required.',
      amountNotNegative: 'Payment amount cannot be negative.',
      discountsNotNegative: 'Discounts cannot be negative.',
      needsCashOrDiscount: 'A payment must carry cash, a discount, or both.',
      clientPaymentIdRequired: 'Client payment id is required.',
      installmentNotFound: 'Installment not found.',
      reviewItemNotFound: 'Review item not found.',
      reviewAlreadyDecided: 'Review item is already decided.',
      rejectionReasonRequired: 'A rejection reason is required.',
      approvedAmountRequired: 'An approved amount greater than zero is required.',
      approvedAmountTooHigh: 'Approved amount exceeds the current balance plus pending late fees.',
    },
    promoters: {
      houseRateNotAPercentage: "The business commission has to be a percentage greater than zero.",
    },
    loans: {
      zoneRequired: 'This borrower needs a zone: pick the one that collects them.',
      emptySchedule: 'The loan parameters produced an empty schedule.',
      notPriced: 'The loan could not be priced: {reason}',
      notFound: 'Loan not found.',
      alreadyPaidOff: 'Loan is already paid off.',
      alreadyCancelled: 'Loan is already cancelled.',
      tableAmountNotFound: 'Loan table amount option not found.',
      principalPositive: 'Principal must be positive.',
      fundingSourceRequired: 'A funding source is required to disburse.',
      promoterNotFound: 'That person is not registered as a promoter.',
      promoterInactive: 'That promoter is no longer active.',
      promoterShareNotConfigured: 'No commission is configured for that promoter or for the business.',
      promoterShareNotPositive: "A promoter's commission has to be greater than zero.",
      promoterShareExceedsLoanRate: "A promoter's commission cannot exceed the loan's own rate.",
      fundingSourceNotFound: 'Funding source not found.',
      installmentsPositive: 'Number of installments must be positive.',
      loanTypeRequired: 'Loan type is required.',
      customerNotFound: 'Customer not found.',
      codeNotAllocated: 'Could not allocate a unique loan code. Try again.',
      ratesNotNegative: 'Rates cannot be negative.',
      onlyOpenLoanChanges: 'Only an open loan can have its terms changed.',
      fundingSourceRetired: '“{name}” is retired and cannot fund a loan.',
      fundingSourceNotOpened: '“{name}” has no opening balance yet. Set it in Settings → Funding sources, then lend from it.',
      ceilingReached: 'This plan allows {ceiling} active loans and {open} are open.',
    },
    treasury: {
      boxNotOurs: 'That cash box does not belong to this business.',
      alreadyClosed: 'That box was already closed for that day. A correction is a separate close.',
      depositBeyondCount: 'You cannot bank more than you counted.',
      depositNeedsDestination: 'Say which account received the deposit.',
    },
    fundingSources: {
      nameRequired: 'A funding source needs a name.',
      sourceGone: 'That funding source no longer exists.',
      openingNotNegative: 'An opening balance cannot be negative.',
      transferPositive: 'A transfer is a positive amount.',
      transferTwoSources: 'A transfer moves money between two different sources.',
      pickTwoOpenSources: 'Pick two of your open funding sources.',
      unknownKind: '“{kind}” is not a kind of funding source.',
      nameTaken: 'There is already a source named “{name}”.',
      saved: '“{name}” saved.',
      openingAlreadySet: '“{name}” already has its opening balance. A correction is an entry of its own.',
      openingSet: '“{name}” opens with {amount}.',
      transferred: 'Moved {amount} from “{from}” to “{to}”.',
      contributionPositive: 'A contribution is a positive amount.',
      sourceRetired: '“{name}” is retired and takes on no new money.',
      contributionAdded: 'Added {amount} to “{name}”.',
    },
    entitlements: {
      trialNotActivated: 'The trial could not be activated: {reason}',
      aliasNotRegistered: 'The device could not be registered with the store: {reason}',
      subscriptionNotFound: 'Subscription not found.',
      trialActivated: 'Trial activated.',
      anonymousIdRequired: 'AnonymousAppUserId is required.',
      deviceLinked: 'Successfully linked device ID to account.',
      appUserIdEmpty: 'AppUserId is empty.',
      ownerDoesNotExist: 'That account does not exist.',
    },
    recovery: {
      codeSentIfExists: 'If an account exists for this email, we just sent a recovery code.',
      completed: 'Recovery completed.',
      completedDeviceReactivated: 'Recovery completed. Device reactivated.',
      passwordNotReset: 'The password could not be reset: {reason}',
      challengeInvalid: 'Recovery challenge invalid.',
      codeInvalid: 'Invalid recovery code.',
      ownerNotFound: 'Owner not found.',
      codeNotConfigured: 'Recovery code not configured for this account.',
      emailAndCodeRequired: 'Email and recovery code are required.',
      accountNotFound: 'Account not found.',
    },
    loanRequests: {
      notCreated: 'The loan could not be created: {reason}',
      notFound: 'Loan request not found.',
      alreadyDecided: 'Loan request is already decided.',
      principalPositive: 'Principal must be positive.',
      installmentsPositive: 'Number of installments must be positive.',
      loanTypeRequired: 'Loan type is required.',
      customerNotFound: 'Customer not found.',
    },
    routes: {
      duplicateCustomer: 'The list contains the same customer more than once.',
      notFound: 'Route not found.',
      customersNotFound: 'One or more customers were not found.',
      nameRequired: 'Route name is required.',
      nameTaken: 'A route with that name already exists.',
      collectorMustBeActive: 'The collector must be an active member of the team.',
    },
    customers: {
      photoExpectedMultipart: 'The photo has to be sent as a file upload.',
      photoTooLarge: 'That photo is too large.',
      photoMissingFilePart: 'No photo came with the request.',
      photoNotStored: 'The photo could not be stored: {reason}',
      firstNameRequired: 'First name is required.',
      lastNameRequired: 'Last name is required.',
      codeNotAllocated: 'Could not allocate a unique customer code. Try again.',
      notFound: 'Customer not found.',
      zoneNotFound: 'Zone not found.',
      riskScoreRange: 'Risk score must be between 0 and 100.',
      zoneClosed: '“{name}” is closed and collects nobody new.',
    },
    admin: {
      requestVerified: 'Request marked as verified. Destructive cleanup is a separate, explicit step.',
      requestRejected: 'Request rejected.',
      trialNotExtended: 'The trial could not be extended: {reason}',
      noAccountMatched: 'No account matched this address. The request was closed with nothing to erase.',
      ownerNotFound: 'Owner not found.',
      platformAdminCannotDeactivate: 'Platform administrators cannot be deactivated through the API.',
      ownerDeactivated: 'Owner deactivated.',
      platformAdminCannotDelete: 'Platform admin accounts cannot be deleted through the API.',
      noSubscription: 'No subscription found for this owner.',
      trialExtended: 'Trial extended.',
      subscriptionNotFound: 'Subscription not found.',
      premiumGranted: 'Premium access granted.',
      premiumReset: 'Premium access reset.',
      ownerReactivated: 'Owner reactivated.',
      emailAlreadyVerified: 'Email already verified.',
      ownerHasNoEmail: 'Owner has no email address.',
      verificationEmailSent: 'Verification email sent.',
      deletionRequestNotFound: 'Deletion request not found.',
      requestAlreadyReviewed: 'This request was already completed and cannot be reviewed again.',
      ownerVerified: 'Owner verified.',
      requestAlreadyCompleted: 'This request was already completed.',
      onlyVerifiedCanComplete: 'Only a verified request can be completed. Verify the requester\'s identity first.',
    },
    loanTables: {
      codeRequired: 'Table code is required.',
      nameRequired: 'Table name is required.',
      countryRequired: 'Country code is required.',
      installmentsPositive: 'Installments must be positive.',
      rateNotNegative: 'Interest rate cannot be negative.',
      optionIncomplete: 'Every amount option needs a positive amount, installment and total.',
      optionBelowPrincipal: 'An amount option cannot total less than its principal.',
      codeTakenByRetired: 'That code belongs to a retired table. Choose another code.',
      codeTaken: 'A table with that code already exists.',
      notFound: 'Loan table not found.',
      systemCannotDelete: 'A system table cannot be deleted.',
      alreadyRetired: 'That table is already retired.',
      systemCannotEdit: 'A system table cannot be edited.',
    },
    devices: {
      linked: 'Device linked.',
      fingerprintRequired: 'Device fingerprint is required.',
      notFound: 'Device not found for this owner.',
      alreadyRevoked: 'Device was already revoked.',
      revoked: 'Device revoked.',
    },
    accountDeletion: {
      exportRequired: 'Export or backup must be offered and completed before account deletion.',
      confirmationRequired: 'Deletion confirmation is required.',
      mustAcknowledgeCancellation: 'The user must acknowledge that subscription cancellation is separate from account deletion.',
      retentionPolicyPending: '{reason}',
      ownerNotFound: 'Owner account not found.',
      onlyOwnerMayDelete: 'Only the owner of this business can delete it. Ask the owner to remove your access instead.',
      completed: 'Account deletion completed.',
      emailRequired: 'Email is required for manual verification.',
      captchaFailed: 'CAPTCHA verification failed.',
      emailInvalid: 'A valid email address is required for manual verification.',
      requestSubmitted: 'Deletion request submitted for manual verification.',
    },
    publicForms: {
      waitlistFieldsRequired: 'Email and country are required.',
      contactFieldsRequired: 'Name, email, and message are required.',
      captchaFailed: 'CAPTCHA verification failed.',
      consentRequired: 'Consent is required for waitlist notifications.',
      contactReceived: 'Contact message received.',
      waitlistReceived: 'Waitlist registration received.',
    },
    commissions: {
      noBands: 'A scheme with no bands pays nothing. To stop paying commission, delete it.',
      firstBandDoesNotStartAtZero: 'The first band must start at zero, or everything collected below it earns nothing without anyone having decided so.',
      twoBandsStartAtTheSameFigure: 'Two bands start at the same figure, so it is undecided which of the two rates applies.',
      bandStartsBelowZero: 'A band cannot start below zero.',
      rateIsNotAPercentage: 'A rate is a percentage between 0 and 100.',
    },
    collections: {
      descriptionRequired: 'Description is required.',
      amountMustBePositive: 'Amount must be positive.',
      loanNotFound: 'Loan not found.',
    },
    settings: {
      businessNameRequired: 'Business name is required.',
      phoneRequired: 'Phone number is required.',
      countryNotSupported: 'That country is not supported.',
      fieldTooLong: '“{field}” is too long.',
    },
    accounting: {
      impairmentPolicySaved: 'Impairment policy saved.',
      impairmentUnknownBand: 'That is not one of the aging bands.',
      impairmentPercentRange: 'A share of a band runs from 0 to 100.',
      impairmentPolicyIncomplete: 'Every band needs a percentage before anything can be posted; a band left unanswered is not the same as one set to zero.',
      impairmentAccountsMissing: 'The engine has no account for the allowance or the loss; point them first.',
      impairmentNothingToPost: 'The allowance already stands where it should.',
      impairmentPosted: 'Impairment posted.',
      importRowNoNumber: 'This row has no account number.',
      importNotANumber: '“{code}” is not an account number.',
      importNoName: '{code} has no name.',
      importDuplicate: '{code} appears more than once.',
      importUnknownClass: '“{stated}” is not a class of account.',
      importNoClass: '{code} does not say which class of account it is, and its number is outside the 1–7 convention.',
      importChildOtherClass: '{code} hangs under {mother}, which is a different class of account.',
      importNothingToImport: 'There is nothing to import.',
      importClassConflict: '{code} already exists as a different class of account; it was left alone.',
      account: {
        needsName: 'An account needs a name.',
        notYours: 'That account is not on this business’s chart.',
        nameTaken: 'Another account is already called “{name}”.',
        opened: '“{name}” opened.',
        saved: '“{name}” saved.',
        motherHidden: '“{name}” is hidden; nothing hangs under it.',
        hiddenForExpense: '“{name}” is hidden; nothing new is charged to it.',
        hiddenForEntry: '“{name}” is hidden; nothing new is posted to it.',
        hiddenForEngine: '“{name}” is hidden; the engine writes to nothing hidden.',
        controlForExpense: '“{name}” groups other accounts; charge this to one of the accounts beneath it.',
        controlForEntry: '“{name}” groups other accounts; post to one of the accounts beneath it.',
        controlForEngine: '“{name}” groups other accounts; point this at one of the accounts beneath it.',
        keptByTheBook: '“{name}” is kept by the book itself; charge this to an account of your own.',
      },
      expense: {
        needsPositiveAmount: 'An expense is a positive amount.',
        needsDescription: 'Say what the money was for.',
        needsExpenseAccount: 'Pick an expense account to charge this to.',
        needsFundingSource: 'Pick the funding source the money left.',
        recorded: 'Expense recorded.',
      },
      entry: {
        needsDescription: 'Say what this entry is for.',
        needsTwoLines: 'An entry needs at least two lines.',
        lineNegative: 'A line cannot carry a negative amount.',
        lineBothSides: 'A line is a debit or a credit, never both.',
        lineMovesNothing: 'A line that moves nothing is not a line.',
        beyondCents: 'Amounts are kept to the cent.',
        unbalanced: 'Debits ({debits}) and credits ({credits}) have to balance.',
        movesNothing: 'An entry that moves nothing is not an entry.',
        needsTwoAccounts: 'An entry moves between two different accounts.',
        accountsNotYours: 'Pick accounts from your own catalogue.',
        inClosedPeriod: 'That month is closed. Use a date in the open period.',
        posted: 'Entry posted.',
      },
      period: {
        closed: 'Period closed.',
        reopened: 'Period reopened.',
        alreadyClosed: 'That period is already closed.',
        notYetOver: 'A day that has not ended cannot be closed.',
        noSigner: 'Your account is not active in this business.',
        nothingToReopen: 'There is no closed period to reopen.',
      },
      engine: {
        identityUnknown: 'No posting rule writes by that name.',
        accountNotYours: 'Pick an account from your own catalogue.',
        alreadyThere: '“{name}” already carries that.',
        wrongClass: '“{name}” is not the right class of account for that; the book would stop tying.',
        accountTaken: '“{name}” is already where another rule writes ({rule}); free it first.',
        nobodyCarriesIt: 'No account carries that right now.',
        moved: 'The engine now posts {rule} to “{name}”.',
      },
      import: {
        fixFileFirst: 'Fix the file first; nothing was imported.',
        nothingWritten: 'Nothing written yet.',
        done: '{added} accounts added and {renamed} renamed.',
      },
    },
  },
  finance: {
    query: {
      search: 'Search the movements',
      anyAccount: 'Any account',
      showing: '{count} movement | {count} movements',
    },
    income: 'Income',
    costs: 'Costs',
    expenses: 'Expenses',
    assets: 'Assets',
    liabilities: 'Liabilities',
    equity: 'Equity',
    profit: 'Profit for the period',
    loss: 'Loss for the period',
    ties: 'The book ties',
    doesNotTie: 'The book is out by',
    result: {
      title: 'Result',
      hint: 'What the business earned against what it spent.',
    },
    statement: {
      title: 'Income statement',
      hint: 'Account by account, what came in against what went out.',
      empty: 'The catalogue holds no income or expense accounts yet.',
    },
    position: {
      title: 'Position',
      hint: 'What the business has against what it owes.',
      asOf: 'As of {date}',
      today: 'As of today',
    },
    period: {
      all: 'The whole book',
      span: '{from} – {to}',
      since: 'From {from}',
      until: 'Until {to}',
      up: '{amount} more than {period}',
      down: '{amount} less than {period}',
      flat: 'Level with {period}',
      quick: {
        thisMonth: 'This month',
        lastMonth: 'Last month',
        thisYear: 'This year',
        all: 'All',
      },
    },
  },
  accounting: {
    title: 'Finances',
    hint: 'Balances come from the entries, and the entries from what already happened on the street.',
    notPurchased:
      'Your plan does not include accounting yet. We have been recording every disbursement and every collection all along: the day you turn it on, your books appear complete from the first loan.',
    balances: 'Balances',
    entries: 'Entries',
    account: 'Account',
    accountName: 'Name',
    debits: 'Debit',
    credits: 'Credit',
    balance: 'Balance',
    debit: 'debit',
    credit: 'credit',
    date: 'Date',
    from: 'From',
    to: 'To',
    description: 'Description',
    lines: 'Lines',
    hidden: 'Hidden',
    showHidden: 'Show hidden',
    visible: 'Visible',
    visibleHint: 'A hidden account drops out of the lists but keeps everything already posted to it. It is never deleted.',
    editAccount: 'Edit account',
    emptyChart: 'No accounts yet.',
    emptyEntries: 'No entries in this range yet.',
    saved: 'Account saved.',
    saveFailed: 'The account could not be saved.',
    expenses: 'Expenses',
    expensesTotal: 'Total',
    emptyExpenses: 'No expenses in this range yet.',
    recordExpense: 'Record expense',
    expenseRecorded: 'Expense recorded.',
    expenseFailed: 'The expense could not be recorded.',
    amount: 'Amount',
    expenseDescriptionPlaceholder: 'Fuel for the bike, collector commission, rent…',
    expenseAccount: 'Charged to',
    expenseAccountPlaceholder: 'Pick the expense account',
    noExpenseAccounts: 'No expense accounts yet. Open one with the button beside — "Fuel" or "Commissions", say.',
    paidFrom: 'Paid from',
    paidFromPlaceholder: 'Pick the source the money left',
    newExpenseAccount: 'New account',
    newExpenseAccountPlaceholder: 'Fuel, Commissions, Rent…',
    newExpenseAccountHint: 'Yours: rename or hide it whenever you like. An account with no parent stays an expense, and those are the ones the expenses you record are charged to.',
    motherAccount: 'Parent account',
    motherAccountPlaceholder: 'None — stands on its own, as an expense account',
    motherAccountHint: 'An account takes its parent’s CLASS, so this decides which side of the balance sheet it lands on. With no parent it stays an expense.',
    motherBecomesTotal: '“{name}” starts totalling whatever hangs beneath it and stops taking movements of its own.',
    motherBecomesTotalWithBalance: '“{name}” starts totalling whatever hangs beneath it. The {amount} it holds today moves onto a new sub-account carrying its name, by a dated entry — this is not a rename.',
    fiscalCode: 'Catalogue number',
    fiscalCodePlaceholder: '110204 — optional, your accountant chooses it',
    chart: {
      systemTab: 'System accounts',
      accountantTab: "Your accountant's chart",
    },
    import: {
      action: 'Import chart',
      title: 'Import a chart of accounts',
      hint: 'Bring in your accountant’s catalogue. Nothing is ever deleted: missing accounts are added and existing ones take the name from the file. The class of an account that already has movements is never changed.',
      paste: 'Paste the catalogue',
      placeholder: '1101,Cash and equivalents\n110101,Cash box\n110103,Bank',
      formatHint: 'One account per line: number, name and — if you like — the class (Asset, Liability, Equity, Income, Cost, Expense, Memorandum). Without it the class is read from the first digit. Commas, semicolons and tabs all work.',
      check: 'See what it would do',
      apply: 'Import',
      willCreate: 'Adds {count} accounts',
      willRename: 'renames {count}',
      problems: 'The file needs fixing before it can be imported:',
      conflicts: 'These are left exactly as they are:',
      line: 'Line {line}',
      failed: 'The catalogue could not be read.',
    },
    periodClose: {
      title: 'Period closing',
      hint: 'A closed period never changes again. A payment that arrives dated inside a closed month keeps the day the money moved and counts in the first open month.',
      through: 'Close through',
      close: 'Close period',
      reopen: 'Reopen',
      closedThrough: 'The books are closed through {date}.',
      nothingClosed: 'No period has been closed yet.',
      notCloseable: 'That date cannot be closed: it is already covered by a close, or the day has not ended.',
      none: 'No closed periods.',
      range: 'Period',
      state: 'State',
      signedBy: 'Closed by',
      openedBy: 'Reopened by',
      closedTag: 'Closed',
      reopenedTag: 'Reopened',
      unknownSigner: 'Not identified',
      reopenWarning: 'This reopens the period from {from} to {to}. Entries that had moved into the open month go back to their own date, and the figures already reported for that month change.',
      loadFailed: 'The periods could not be loaded.',
      closed: 'Period closed.',
      closeFailed: 'The period could not be closed.',
      reopenFailed: 'The period could not be reopened.',
      reopenedCount: 'Period reopened. Entries moved back to their own day: {count}.',
    },
    impairment: {
      title: 'Portfolio impairment',
      hint: 'What the book does not expect to collect. The percentages are YOURS: the system applies them to the overdue portfolio and shows the estimate, but has no opinion about what they should be. Only the difference against what is already provisioned gets booked.',
      band: 'Band',
      daysLate: '{label} days',
      portfolio: 'Portfolio',
      percent: '%',
      estimated: 'Estimated',
      required: 'Required',
      provisioned: 'Already provisioned',
      movement: 'To book today',
      incomplete: 'A band has no percentage yet. An unanswered band is not a band set to zero — save it before booking.',
      accountsMissing: 'Your chart has no impairment accounts. Point them again under "Where the engine writes".',
      savePolicy: 'Save percentages',
      saved: 'Percentages saved.',
      saveFailed: 'The percentages could not be saved.',
      post: 'Book it',
      posted: 'Impairment booked.',
      postFailed: 'The impairment could not be booked.',
    },
    engine: {
      title: 'Where the engine writes',
      hint: 'Eleven rules record what happens on the street on their own. This says which account in YOUR catalogue each one lands on. Changing one carries its balance across by a dated entry.',
      rule: 'Rule',
      postsTo: 'Posts to',
      change: 'Change',
      nowhere: 'No account',
      moved: 'The engine now posts to the new account.',
      failed: 'The engine account could not be changed.',
      movingHint: '“{rule}” lands on “{account}” today. Whatever that account holds moves across by a dated entry — nothing already written is rewritten.',
      noCandidates: 'You have no account of your own of that class yet. Open one first: a rule can only land on a movement account of the same class.',
      dateHint: 'The date of the reclassification entry. It is the day you decide the change, not the date of the older movements.',
      codes: {
        LOANS_RECEIVABLE: 'Loans receivable',
        CASH: 'Cash box',
        BANK: 'Bank',
        OPENING_BALANCES: 'Opening balances',
        INTEREST_INCOME: 'Interest earned',
        MORA_INCOME: 'Late interest collected',
        COLLECTION_FEES_INCOME: 'Collection fees',
        DISCOUNTS_GRANTED: 'Discounts granted',
        WRITE_OFFS: 'Written off',
        IMPAIRMENT_ALLOWANCE: 'Impairment allowance',
        IMPAIRMENT_EXPENSE: 'Impairment expense',
      },
      writes: {
        LOANS_RECEIVABLE: 'The principal out on the street: up on disbursement, down as it comes back.',
        CASH: 'Cash in the box.',
        BANK: 'Money in the account.',
        OPENING_BALANCES: 'What the book was opened against on day one.',
        INTEREST_INCOME: 'Interest, as it is collected.',
        MORA_INCOME: 'Late interest, as it is collected.',
        COLLECTION_FEES_INCOME: 'Collection fees, as they are collected.',
        DISCOUNTS_GRANTED: 'What was decided not to collect.',
        WRITE_OFFS: 'Principal that never came back.',
        IMPAIRMENT_ALLOWANCE: 'What is estimated uncollectible, subtracting from the portfolio.',
        IMPAIRMENT_EXPENSE: 'The estimated loss, charged to the period.',
      },
    },
    kinds: {
      asset: 'Asset',
      liability: 'Liability',
      equity: 'Equity',
      income: 'Income',
      expense: 'Expense',
      cost: 'Cost',
      memorandum: 'Memorandum',
    },
    controlAccount: 'Groups sub-accounts',
    newEntry: 'New entry',
    newEntryHint:
      'What the street does not produce on its own: an accrual, a depreciation, an adjustment. You name both accounts, so the book only takes it if it balances.',
    entryDescriptionPlaceholder: 'August depreciation, payroll accrual…',
    entryAccountPlaceholder: 'Search by number or by name',
    addLine: 'Add line',
    removeLine: 'Remove line',
    difference: 'Difference',
    postEntry: 'Post entry',
    entryPosted: 'Entry posted.',
    entryFailed: 'The entry could not be posted.',
    manualEntry: 'Manual',
    raisedBy: {
      debit: 'Raised by a debit',
      credit: 'Raised by a credit',
    },
    entryProblem: {
      noDate: 'Give the entry a date.',
      noDescription: 'Say what this entry is for.',
      tooFewLines: 'An entry needs at least two lines: one balances against nothing.',
      noAccount: 'One line still has no account.',
      bothSides: 'A line is a debit or a credit, never both.',
      noAmount: 'One line still has no amount.',
      beyondCents: 'Amounts are kept to the cent.',
      sameAccount: 'Both sides land on the same account: it ends where it started.',
      unbalanced: 'Debits and credits do not balance yet.',
    },
  },
  fundingSources: {
    title: 'Where the money comes from',
    hint: 'Every disbursement names one. Add one for each place you take cash out of — the box, an account, a partner.',
    create: 'New source',
    edit: 'Edit source',
    emptyList: 'No funding sources yet.',
    name: 'Name',
    kind: 'Kind',
    status: 'Status',
    loans: 'Loans',
    active: 'Active',
    retired: 'Retired',
    activeLabel: 'Available to disburse from',
    retireHint:
      'Retiring it takes it off the disbursement picker but leaves it on the loans it already paid for.',
    openingBalance: 'Opening balance',
    setOpening: 'Set opening balance',
    openingTitle: 'Opening balance for {name}',
    openingHint:
      'What this source held the day the book started. Nobody was counting it before, so the ledger cannot know; without it every disbursement drives the cash account below zero.',
    openingAmount: 'Amount',
    openingDate: 'As of',
    openingOnce: 'Said once. A later correction is an entry of its own, not a change to this figure.',
    openingSaved: 'Opening balance recorded.',
    openingFailed: 'The opening balance could not be recorded.',
    transfer: 'Transfer',
    transferHint:
      'The same money changing pocket: the box deposited at the bank, the bank drawn down into the box. Neither an expense nor income.',
    transferFrom: 'From',
    transferTo: 'To',
    transferPick: 'Pick a source',
    transferDate: 'Date',
    transferDescription: 'Note',
    transferDescriptionPlaceholder: "The week's deposit",
    transferSaved: 'Transfer recorded.',
    transferFailed: 'The transfer could not be recorded.',
    contributed: 'Contributions',
    addMoney: 'Add money',
    contributionTitle: 'Add money to {name}',
    contributionHint:
      'Your own money going into this source after it was opened: the partner who puts in more, the owner refilling the box. It does not come out of another source, and the business did not earn it.',
    contributionAmount: 'Amount',
    contributionDate: 'Date',
    contributionDescription: 'Concept',
    contributionSaved: 'Contribution recorded.',
    contributionFailed: 'The contribution could not be recorded.',
    saved: 'Funding source saved.',
    saveFailed: 'The funding source could not be saved.',
    kinds: {
      Cash: 'Cash',
      Bank: 'Bank account',
      Partner: 'Partner',
      Other: 'Other',
    },
  },
  settings: {
    profile: {
      title: 'My details',
      passwordTitle: 'My password',
      firstName: 'First name',
      lastName: 'Last name',
      phone: 'Phone',
      address: 'Address',
      addressHint: 'Optional.',
      idNumber: 'ID number',
      identityNote: 'Your email and ID number are managed by your business.',
      save: 'Save my details',
      changePhoto: 'Change photo',
      removePhoto: 'Remove photo',
      photoFailed: 'The photo could not be saved.',
      saved: 'Your details were updated.',
      failed: 'Your details could not be saved.',
    },
    title: 'Settings',
    save: 'Save',
    saved: 'Settings saved.',
    saveFailed: 'Settings could not be saved.',
    loadFailed: 'Settings could not be loaded.',
    tabs: {
      profile: 'Business',
      promoters: 'Promoters',
      funding: 'Funding',
      account: 'Account',
      subscription: 'Subscription',
    },
    businessProfile: {
      title: 'Business profile',
      hint: 'What your receipts and reports print.',
      notConfigured: 'Not set up yet — these are the same defaults your phone prints.',
    },
    fields: {
      businessName: 'Business name',
      displayName: 'Your name',
      phoneNumber: 'Phone',
      countryCode: 'Country',
      email: 'Email',
      slogan: 'Slogan',
      addressLine: 'Address',
      receiptFooter: 'Receipt footer',
    },
    toggles: {
      receiptTitle: 'On receipts',
      receiptHint: 'Each switch adds or removes a line from the printed receipt.',
      reportTitle: 'On reports',
      showBusinessNameOnReceipt: 'Business name',
      showDisplayNameOnReceipt: 'Your name',
      showPhoneOnReceipt: 'Phone',
      showSloganOnReceipt: 'Slogan',
      showLoanStartDateOnReceipt: 'Loan start date',
      showLoanEndDateOnReceipt: 'Loan end date',
      showInterestRateOnReceipt: 'Interest rate',
      showBusinessNameOnReports: 'Business name',
      showDisplayNameOnReports: 'Your name',
      showPhoneOnReports: 'Phone',
      showSloganOnReports: 'Slogan',
    },
    password: {
      title: 'Change password',
      hint: 'Signing in again will be needed on your other devices.',
      mustChangeHint: 'Your account was created with a temporary password. Choose your own before doing anything else.',
      current: 'Current password',
      new: 'New password',
      confirm: 'Confirm new password',
      submit: 'Change password',
      mismatch: 'The two new passwords do not match.',
      changed: 'Password updated.',
      failed: 'Password could not be changed.',
      otherDevices: 'Your other sessions were signed out.',
    },
    subscription: {
      title: 'Subscription',
      hint: 'Your StreetLoans Plus plan.',
      none: 'No subscription on file for this business.',
      status: 'Status',
      plan: 'Plan',
      seats: 'Seats',
      trialEnds: 'Trial ends',
      periodEnds: 'Period ends',
      writes: 'Changes',
      writesAllowed: 'Allowed',
      writesBlocked: 'Read-only',
      manageOnPhone: 'Plans are purchased in the mobile app.',
      statuses: {
        Trialing: 'Trial',
        Active: 'Active',
        PastDue: 'Past due',
        Canceled: 'Canceled',
        Unknown: 'Unknown',
      },
    },
  },
  paymentReview: {
    title: 'Payments to review',
    emptyQueue: 'Nothing to review.',
    reason: 'Reason',
    collected: 'Collected',
    currentCap: 'Current ceiling',
    submitted: 'Submitted',
    approve: 'Approve',
    reject: 'Reject',
    approveTitle: 'Approve payment',
    approveHint: 'Record up to {cap} (current balance plus pending late fees).',
    approvedAmount: 'Amount to record',
    rejectTitle: 'Reject payment',
    rejectReason: 'Reason (required)',
    approved_success: 'Payment approved.',
    rejected_success: 'Payment rejected.',
    actionFailed: 'The decision could not be completed.',
    reasons: {
      ExceedsBalance: 'Exceeds balance',
      AlreadyPaid: 'Already paid',
    },
  },
  migration: {
    title: 'Import your book',
    hint: 'Bring the customers, loans and payments from the StreetLoans mobile app. Export a backup from the app, then upload the file here.',
    pickFile: 'Choose backup file',
    previewTitle: 'What the backup contains',
    customers: 'Customers',
    loans: 'Loans',
    installments: 'Installments',
    payments: 'Payments',
    skippedLoans: 'Skipped loans (archived or in progress)',
    loansWithDefaultType: 'Loans imported with the default type',
    oneWayWarning:
      'This is a one-time import into an empty book. Overdue amounts are recalculated by the platform after the import.',
    confirm: 'Import book',
    successTitle: 'Book imported',
    requestFailed: 'The import could not be completed. Try again.',
    parseErrors: {
      'invalid-json': 'That file is not a valid backup (corrupt JSON).',
      'missing-data': 'That file does not look like a StreetLoans backup.',
    },
  },
  commissions: {
    title: 'Collector commission',
    lede: 'What the business pays each collector on what they bring in. This is not the collection fee, which is charged to the customer.',
    notSetYet: 'No scheme is set yet, so no commission is paid today. Build the bands, rehearse them against what has already been collected, and save.',
    bandsTitle: 'Bands',
    bandsNote: 'Bands are marginal, like income tax: crossing a threshold lifts the rate on the excess only. The base is principal plus interest — mora and collection fees earn nothing, because they grow when a customer falls behind and it is the collector who decides when to visit. It is earned when the cash reaches the box, never when the payment is recorded: nothing is owed on money still in the street. The window is weekly.',
    from: 'From',
    rate: 'Rate',
    addBand: 'Add band',
    removeBand: 'Remove band',
    save: 'Save scheme',
    saved: 'Scheme saved.',
    saveFailed: 'The scheme could not be saved.',
    rehearsalTitle: 'Rehearsal against past collections',
    rehearsalNote: 'What this scheme would have paid over collections that already happened. It rehearses what is typed above, saved or not, and writes nothing.',
    rangeFrom: 'From',
    rangeTo: 'To',
    rehearse: 'Rehearse',
    rehearsalFailed: 'The rehearsal could not be calculated.',
    collector: 'Collector',
    collected: 'Collected base',
    commission: 'Commission',
    totalBase: 'Total base',
    totalCommission: 'Total commission',
    nothingCollected: 'Nothing was collected in that range.',
    unknownCollector: 'Former collector',
  },
  loans: {
    title: 'Loans',
    code: 'Code',
    borrower: 'Borrower',
    principal: 'Principal',
    interestRate: 'Interest rate',
    installment: 'Installment',
    total: 'Total to collect',
    outstanding: 'Owes',
    installmentsCount: '{count} instalments',
    disbursed: 'Disbursed',
    fundedFrom: 'Money came from',
    fundedFromUnknown: 'Not recorded',
    schedule: 'Schedule',
    installments: 'Installments',
    number: '#',
    dueDate: 'Due date',
    expected: 'Expected',
    paid: 'Paid',
    balance: 'Balance',
    status: 'Status',
    view: 'View loan',
    paidTag: 'Paid',
    pastDue: 'Past due',
    pending: 'Pending',
    mora: 'Late fee',
    pendingMora: 'Pending late fees',
    daysOverdue: 'Days overdue',
    daysCount: '{count} day | {count} days',
    emptyList: 'No loans found.',
    nobodyAssigned: 'No customers have been assigned to your route yet. The office assigns them from Routes.',
    create: 'New loan',
    customer: 'Customer',
    searchCustomer: 'Search customer',
    type: 'Loan type',
    frequencyLabel: 'Frequency',
    latePaymentRate: 'Late payment rate',
    currency: 'Currency',
    notes: 'Notes',
    created_success: 'Loan created.',
    actionFailed: 'The loan could not be created.',
    cancelLoan: 'Cancel loan',
    cancelConfirm:
      'This will cancel the loan and exclude it from business reports. This action cannot be undone.',
    cancelReason: 'Reason (optional)',
    cancelled_success: 'Loan cancelled.',
    cancelFailed: 'The loan could not be cancelled.',
    types: {
      SIMPLE: 'Simple interest',
      FRENCH: 'French (amortized)',
      GERMAN: 'German (declining)',
      GOTA_GOTA: 'Gota a gota',
      IMPLIED_RATE: 'Implied rate',
    },
    frequency: {
      daily: 'daily',
      weekly: 'weekly',
      biWeekly: 'bi-weekly',
      monthly: 'monthly',
    },
    frequencyOption: {
      daily: 'Daily',
      weekly: 'Weekly',
      biWeekly: 'Bi-weekly',
      monthly: 'Monthly',
      unknown: 'Unknown',
    },
    frequencyFallback: 'unknown',
    statuses: {
      inProgress: 'In progress',
      active: 'Active',
      paidOff: 'Paid off',
      overdue: 'Overdue',
      cancelled: 'Cancelled',
    },
  },
  gotaGota: {
    pickPlan: 'Pick a plan',
    typeTermsInstead: 'Type the terms instead',
    flatRate: '{rate}% flat',
    amountCount: 'no amounts | 1 amount | {count} amounts',
    howOften: 'How often do you collect?',
    cadences: {
      daily: 'Daily',
      weekly: 'Weekly',
      biWeekly: 'Fortnightly',
      monthly: 'Monthly',
    },
    scheduleHint: 'Every day · {installments} | Every {days} days · {installments}',
    installmentCount: '{count} installment | {count} installments',
    pickAmount: 'Pick the amount',
    loadingAmounts: 'Loading amounts…',
    capital: 'Capital',
    perVisit: 'Installment',
    summary: '{installments} of {installment} · {total} in total',
    totalLabel: 'in total',
  },
  loanCalculator: {
    title: 'Loan calculator',
    fromTable: 'Price from a table',
    chooseTable: 'No table — type the terms',
    tableAmount: 'Amount',
    chooseAmount: 'Choose an amount',
    monthlyRate: 'Monthly rate',
    monthlyRateHint: 'Enter the MONTHLY rate — it is multiplied by 12 to get the annual rate.',
    calculating: 'Calculating…',
    invalidParameters: 'These parameters do not produce a valid loan.',
    cadence: {
      daily: '{count} daily installment | {count} daily installments',
      weekly: '{count} weekly installment | {count} weekly installments',
      biWeekly: '{count} fortnightly installment | {count} fortnightly installments',
      monthly: '{count} monthly installment | {count} monthly installments',
    },
    periodicPayment: 'Periodic payment',
    totalAmount: 'Total to collect',
    totalInterest: 'Total interest',
    ear: 'Effective annual rate',
    period: '#',
    paymentAmount: 'Payment',
    interestPart: 'Interest',
    principalPart: 'Principal',
    remainingBalance: 'Balance',
  },
  collections: {
    title: 'To collect today',
    refresh: 'Refresh',
    visitOrder: 'Stop',
    dueToday: 'Due today',
    emptyList: 'Nothing to collect today.',
    nobodyAssigned: 'No customers have been assigned to your route yet. The office assigns them from Routes.',
    chooseRoute: 'Choose route',
    noRoute: 'No route',
    toCollect: 'To collect',
    collectedToday: 'Collected today',
    visits: 'Visits',
    collected: 'Collected',
    visitDone: 'Visit done',
    daysLate: '{count} day late | {count} days late',
    installmentShort: 'Installment {number}',
  },
  collect: {
      waiveTitle: 'How much are you forgiving?',
      waiveNothing: 'There is nothing to forgive on this installment.',
      waiveSummary: 'Forgiving {waived} · collecting {cash}',
      waiveOf: {
        interest: 'Interest',
        mora: 'Late interest',
        collectionFees: 'Collection fees',
      },
    selectInstallments: 'Mark the installments you are collecting',
    owedToday: 'Owed today',
    owedParts: 'Installment {balance} + mora {mora}',
    collectedAll: 'Collected it all',
    collectedOther: 'Collected another amount',
    collectedOtherHint: 'partial payment',
    waiveLink: 'Waive interest or mora',
    viewLoan: 'View the whole loan',
    notPaidNext: 'Did not pay today · next',
    notPaidClose: 'Did not pay today',
    howMuch: 'How much did they pay?',
    amountCollected: 'Amount collected',
    remaining: '{amount} of {owed} still owed',
    tooHigh: 'Cannot exceed {owed}',
    backspace: 'Delete',
    record: 'Record',
    collectedAmount: 'Collected {amount}',
    savedOffline: 'Saved offline: it will be sent when back online',
    queuedForReview: 'Sent to the office for review',
    stillOwes: '{amount} still owed',
    installmentSettled: 'Installment settled',
    sendReceipt: 'Send receipt',
    sendReceiptHint: 'WhatsApp · share · print',
    sendProvisionalReceipt: 'Send provisional receipt',
    sendProvisionalReceiptHint: 'offline · with a code for the office',
    nextCustomer: 'Next customer',
    backToList: 'Back to the list',
    owedPartsMulti: '{count} installment + mora {mora} | {count} installments + mora {mora}',
    installmentsCollected: '{count} installment collected | {count} installments collected',
    viewLoanReceiptsHint: "each installment's receipt lives there",
  },
  provisionalReceipt: {
    dialogTitle: 'Provisional receipt',
    title: 'PAYMENT RECEIPT',
    provisional: 'PROVISIONAL',
    pendingNote: 'Pending confirmation by the office. Keep this code.',
    code: 'Code',
    date: 'Date',
    customer: 'Customer',
    loan: 'Loan',
    installment: 'Installment',
    amount: 'Amount received',
    remaining: 'Principal still owed',
    collector: 'Collector',
    shareTitle: 'Provisional receipt',
    warning:
      'Offline: this receipt is provisional. Its code {code} identifies the payment; the office confirms it once the phone reconnects.',
    signature: 'Signature',
    unsigned: 'Unsigned: the phone had no key when it was issued.',
    signatureNote: 'Signature {signature}: the office can check it came from this app.',
    failed: 'The receipt could not be drawn on this device.',
  },
  provisionalLookup: {
    title: 'Verify a provisional receipt',
    hint: 'Type the 8-character code and the date printed on the receipt the collector gave while offline.',
    code: 'Code',
    date: 'Receipt date',
    search: 'Verify',
    recorded: 'Payment recorded',
    queued: 'Payment in office review',
    rejected: 'Payment rejected in review',
    missing: 'That payment did NOT reach the system. The customer holds a receipt for a payment nobody reported: ask the collector of that date.',
    amount: 'Amount',
    signature: 'Signature',
    scan: 'Read the ticket QR',
    genuine: 'Genuine receipt: it came from {who}’s app.',
    genuineButMissing:
      'GENUINE receipt, issued by {who}’s app, but the payment did NOT reach the system: that collector took the money and did not report it.',
    forged: 'INVALID signature: this receipt did not come from the system or was altered (amount, date or code).',
    recordedBy: 'recorded by {who}',
  },
  myPayments: {
    title: 'My collections',
    emptyList: 'No payments recorded in this range.',
    total: '1 payment, total | {count} payments, total',
  },
  cashClose: {
    title: 'Cash close',
    box: 'Cash box',
    chooseBox: 'Choose the box',
    date: 'Date',
    expected: 'What the book says',
    counted: 'Cash counted',
    short: '{amount} short. It is recorded as a shortfall.',
    over: '{amount} over. It is recorded as a surplus.',
    ties: 'The box ties.',
    deposited: 'Banked',
    depositTo: 'Into',
    chooseBank: 'Choose the account',
    remaining: 'Left in the box: {amount}',
    depositBeyondCount: 'You cannot bank more than you counted.',
    notes: 'Notes',
    close: 'Close the box',
    closed: 'Box closed.',
    failed: 'The box could not be closed.',
    sharesGeneralAccount: 'This box has no ledger account of its own: it shares the general cash account with the others, so the book cannot say what it holds on its own. Give it an account of its own to close it.',
  },
  loanTables: {
    title: 'Gota a gota tables',
    create: 'New table',
    editTitle: 'Edit table',
    edit: 'Edit table',
    code: 'Code',
    name: 'Name',
    country: 'Country',
    system: 'System',
    amountCount: 'Amounts',
    amountOptions: 'Amounts',
    addAmount: 'Add amount',
    removeAmount: 'Remove amount',
    amount: 'Principal',
    installmentAmount: 'Per installment',
    totalToPay: 'Total to pay',
    noAmounts: 'No amounts yet. Add one to price this table.',
    retire: 'Retire',
    retireTitle: 'Retire table',
    retireConfirm:
      'Retire the table “{code}”? It stops appearing in the list, and loans already priced from it keep working.',
    emptyList: 'No tables yet.',
    created_success: 'Table created.',
    updated_success: 'Table updated.',
    retired_success: 'Table retired.',
    actionFailed: 'The operation could not be completed.',
    errors: {
      codeRequired: 'The code is required.',
      nameRequired: 'The name is required.',
      countryRequired: 'The country is required.',
      installmentsPositive: 'Installments must be greater than zero.',
      rateNonNegative: 'The interest rate cannot be negative.',
      optionPositive: 'Every amount needs a positive principal, installment and total.',
      optionBelowPrincipal: 'An amount cannot total less than its principal.',
    },
  },
  loanRequests: {
    disburse: {
      title: 'Disburse loan',
      fundingSource: 'Money comes from',
      fundingSourcePlaceholder: 'Pick a source',
      fundingSourceHint: 'Which of your sources this money leaves. Nobody can work this out afterwards.',
      zone: 'Collected in',
      zoneKept: 'Already on this route: they stay with the collector who walks to them. Moving them is a separate act, from the customer.',
      zonePlaceholder: 'Pick a route',
      zoneHint: 'A collector only sees the customers on their own routes. Left out of one, nobody on the street can collect this loan.',
      fundingSourcesFailed: 'Your funding sources could not be loaded, so nothing can be disbursed right now.',
      action: 'Disburse',
      confirm: 'Disburse',
      date: 'Start date',
      dateHint: 'The day the money actually changed hands. Every due date counts from here.',
      schedule: 'Installment schedule',
      quoteFailed: 'The schedule could not be calculated with these terms.',
      warning: 'Confirming creates the loan and puts it on the street. It cannot be undone.',
    },
    applicant: 'Borrower',
    applicantHint: 'Type the ID number first — if they already borrowed from you, the rest fills itself in.',
    idNumberPlaceholder: 'ID number',
    lookupSearching: 'Looking up that ID number…',
    lookupFound: 'Already on your books ({code}). Their details were filled in.',
    customerNotes: 'Notes about the borrower',
    terms: 'Loan terms',
    photoAfterApproval: 'A photo can be attached once this request is approved and the borrower is on your books.',
    title: 'My loan requests',
    queueTitle: 'Pending approvals',
    create: 'New request',
    requested: 'Requested',
    status: 'Status',
    decisionReason: 'Decision reason',
    approve: 'Approve',
    reject: 'Reject',
    rejectTitle: 'Reject request',
    rejectReason: 'Reason (optional)',
    emptyList: 'No requests filed yet.',
    emptyQueue: 'Nothing waiting for approval.',
    created_success: 'Request submitted for approval.',
    createFailed: 'The request could not be submitted.',
    photo: 'Customer photo',
    attachPhoto: 'Attach photo',
    photoUploadFailed: 'The request was filed, but the photo could not be attached.',
    photoRejected: {
      type: 'Only PNG, JPEG and WEBP images are accepted.',
      size: 'The photo cannot exceed 5 MB.',
    },
    approved_success: 'Request approved — the loan was created.',
    rejected_success: 'Request rejected.',
    actionFailed: 'The operation could not be completed.',
    statuses: {
      Pending: 'Pending',
      Approved: 'Approved',
      Rejected: 'Rejected',
    },
  },
  outbox: {
    pending: '{count} to sync',
    pendingHint: 'Payments saved offline, waiting to reach the server.',
  },
  subscription: {
    trialDaysLeft: '{count} days left in your free trial.',
    readOnly: 'Your subscription is inactive — the books are read-only. Nothing is deleted; renew to keep working.',
    unknown: 'We could not check your subscription. Saving is off until we can — this is not an expiry.',
    retry: 'Try again',
  },
  collectionActivities: {
    title: 'Collection visits',
    record: 'Record visit',
    date: 'Date',
    description: 'Description',
    amount: 'Fee',
    outstanding: 'Outstanding',
    agreementNote: 'Agreement',
    settled: 'Settled',
    pending: 'Pending',
    empty: 'No visits recorded for this loan.',
    recorded_success: 'Visit recorded.',
    actionFailed: 'The operation could not be completed.',
    errors: {
      descriptionRequired: 'A description is required.',
      amountPositive: 'The fee must be greater than zero.',
      dateRequired: 'A date is required.',
    },
  },
  reports: {
    exportCsv: 'Export CSV',
    exportFailed: 'The report could not be exported. Try again.',
    exportEmpty: 'Nothing was collected in that range, so there is nothing to export.',
    monthlyFlowTitle: 'Disbursed vs recovered',
    collectionsTrendTitle: 'Collections in the period',
    collectedInWindow: 'collected in the chosen range',
    noFlow: 'No movement to chart yet.',
    topCustomersTitle: 'Top borrowers',
    disbursed: 'Disbursed',
    recovered: 'Recovered',
    outstanding: 'Outstanding',
    loanCount: 'Loans',
    noChartData: 'Nothing to chart yet.',
    noTopCustomers: 'No borrowers with an outstanding balance.',
    months: {
      1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun',
      7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec',
    },
  },
  payments: {
    preview: {
      title: 'This is where it lands',
      collectionFees: 'Collection fees',
      mora: 'Late fees',
      interest: 'Interest',
      principal: 'Principal',
      unapplied: '{amount} has nowhere to land. The server will refuse the payment.',
    },
    fundingSource: 'Where did the money go?',
    chooseFundingSource: 'Pick the source',
    breakdownTitle: 'Payment breakdown',
    applied: 'Applied to',
    waived: 'Waived',
    waivedNote: 'Waived amounts are not part of the sum collected.',
    breakdownMismatch: 'The buckets below do not add up to the amount collected.',
    downloadReceipt: 'Receipt',
    receiptTitle: 'Receipt',
    receiptShare: 'Send',
    receiptShareTitle: 'Payment receipt',
    receiptOpen: 'View or print',
    receiptSave: 'Save',
    receiptShareUnsupported: 'This browser cannot pass the file to another app. Save it and attach it yourself.',
    receiptNotFound: 'There is no receipt for this payment.',
    receiptFailed: 'The receipt could not be downloaded. Try again.',
    receiptServerFailed: 'The server could not build the receipt. The payment IS recorded; report it so it can be looked at.',
    receiptUnreachable: 'The server could not be reached for the receipt. Check the connection.',
    receiptEmpty: 'The server returned an empty receipt. Report it so it can be looked at.',
    appliedToCollectionFees: 'Collection fees',
    discountInterest: 'Interest',
    discountMora: 'Late fees',
    discountCollectionFees: 'Collection fees',
    discounts: 'Discounts',
    discountAvailable: 'Available: {amount}',
    discountsUnavailable: 'Could not load the amounts available to waive. You can still record the payment without discounts.',
    cashDue: 'Cash to collect',
    record: 'Record payment',
    history: 'Payment history',
    date: 'Date',
    amount: 'Amount',
    appliedToInterest: 'To interest',
    appliedToPrincipal: 'To principal',
    appliedToMora: 'To late fees',
    receipt: 'Receipt',
    amountPlaceholder: 'What they handed over',
    debtUnavailable: 'The debt breakdown could not be loaded. You can still record the payment.',
    debt: {
      title: 'Owes in total',
      installments: 'See {count} instalments pending',
      overdueCount: '{count} overdue',
    },
    notes: 'Notes',
    recorded_success: 'Payment recorded.',
    savedOffline: 'Saved offline — it will sync when you reconnect.',
    queuedForReview: 'Saved and sent for review (it exceeds the balance or the installment was paid).',
    actionFailed: 'The payment could not be recorded.',
    emptyHistory: 'No payments recorded yet.',
  },
  customers: {
    title: 'Customers',
    search: 'Search customers',
    create: 'New customer',
    code: 'Code',
    name: 'Name',
    firstName: 'First name',
    lastName: 'Last name',
    nickName: 'Nickname',
    idNumber: 'ID number',
    newLoan: 'New loan',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    reference: 'Reference',
    notes: 'Notes',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    blacklisted: 'Blacklisted',
    created_success: 'Customer created.',
    updated_success: 'Customer updated.',
    actionFailed: 'The operation could not be completed.',
    zone: 'Route',
    noZone: 'No route',
    noZoneHint: 'No collector walks to this customer until they are on a route.',
    changeZone: 'Change route',
    placeInZone: 'Place in a route',
    zoneDialogTitle: 'Route for {name}',
    zonePlaceholder: 'Pick the route that collects them',
    zoneAppendedHint: 'They go to the end of that route’s walk; the order is set from the route.',
    removeFromZone: 'Remove from route',
    zoneNoneOpen: 'No route is open. Create one under Routes first.',
    zone_updated_success: 'Route updated.',
    emptyList: 'No customers found.',
    view: 'View customer',
    edit: 'Edit customer',
    save: 'Save changes',
    riskScore: 'Risk score',
  },
  recovery: {
    forgot: 'Forgot your password?',
    title: 'Recover your access',
    hint: 'Enter your email and we will send you a link to create a new password.',
    submit: 'Send the link',
    sentTitle: 'Check your email',
    sentBody: 'If {email} has an account, a link to create a new password is on its way. It expires in an hour.',
    backToLogin: 'Back to sign in',
    sendAgain: 'Send it again',
    sendAgainIn: 'You can send it again in {seconds}s',
    changeEmail: 'Use another address',
    resetTitle: 'Create a new password',
    resetHint: 'Choose a password of at least 10 characters.',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    mismatch: 'The passwords do not match.',
    noToken: 'The link is missing. Open the one that arrived by email.',
    failed: 'The password could not be changed.',
    doneTitle: 'Your password has been changed',
    doneBody: 'You can sign in with your new password. For your safety, your other sessions were closed.',
    resetSubmit: 'Change my password',
  },
  login: {
    failure: {
      credentials: 'Invalid credentials.',
      throttled: 'Too many attempts in a row. Wait a minute and try again — your password may be fine.',
      unreachable: 'The server could not be reached. Check your connection.',
      serverError: 'The server answered with an error. This is not your password — try again in a moment.',
      deviceUnidentified: 'This browser could not identify itself. Leave private mode or allow site storage, then try again.',
    },
    title: 'StreetLoans',
    formTitle: 'Welcome',
    formHint: 'Sign in with your account email and password.',
    tagline: 'Your lending operation, complete.',
    platformTagline: 'Product administration.',
    rememberMe: 'Remember my email',
    madeBy: 'A PinotechRD LLC product',
    features: {
      portfolio: 'Loans and portfolio',
      collectors: 'Collectors on route, with a signed receipt',
      cash: 'Cash box, closes and commissions',
      accounting: 'Accounting with financial statements',
      reports: 'Reports and portfolio risk',
    },
    email: 'Email',
    password: 'Password',
    submit: 'Log in',
    failed: 'Invalid credentials.',
    platformTitle: 'Platform console',
    platformHint: 'Administer the product itself. Only the platform operator signs in here.',
    platformOnly: 'That account belongs to a business, not to the platform. Sign in through your own business instead.',
    goToBusinessLogin: 'Go to the business sign-in',
  },
  dashboard: {
    headline: {
      collected: 'Collected in the period',
      collectedNote: 'Principal, interest and late fees that came back.',
      outstandingNote: 'Across {count} loans on the street.',
      atRiskNote: 'Portfolio at risk 30+: {percent}.',
      atRiskShortNote: 'Overdue capital that has not come back yet.',
    },
    loansOnTheStreet: 'Loans on the street',
    loansWithOutstandingBalance: 'Loans with a balance',
    risk: {
      title: 'Portfolio health',
      par30: 'Portfolio at risk (30+ days)',
      par30Hint: 'The whole balance of loans more than 30 days late, over {portfolio} on the street.',
      efficiency: 'Collection efficiency',
      efficiencyHint: 'Collected against what the schedule said was due in the period: {expected}.',
      efficiencyOver: 'Above 100% because more came in than fell due: somebody paid ahead or cleared arrears.',
      interestInArrears: 'Interest in arrears',
      waived: 'Waived in the period',
      waivedSplit: 'Interest {interest} · Late fees {mora} · Charges {fees}',
      agingTitle: 'Arrears aging',
      agingHint: 'How much principal and interest is past due, by how many days late it is.',
      daysLate: 'Days late',
      principal: 'Principal',
      interest: 'Interest',
      total: 'Total',
    },
    title: 'Business state',
    from: 'From',
    to: 'To',
    apply: 'Apply',
    clear: 'Clear',
    rangeHint: 'The date range filters collections only; capital lent is always all-time.',
    movement: {
      title: 'Movement in the period',
    },
    size: {
      title: 'Size of the book',
    },
    capitalLent: 'Capital lent',
    capitalRecovered: 'Capital recovered',
    capitalOutstanding: 'Capital outstanding',
    interestCollected: 'Interest collected',
    capitalInArrears: 'Capital in arrears',
    moraCollected: 'Late fees collected',
    collectionFeesCollected: 'Collection fees collected',
  },
  common: {
    close: 'Close',
    actionFailed: 'The operation could not be completed.',
    actions: 'Actions',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    back: 'Back',
    cancel: 'Cancel',
    save: 'Save',
    search: 'Search',
    refresh: 'Refresh',
    dismiss: 'Dismiss',
    loadFailed: 'Data could not be loaded.',
    loading: 'Loading…',
    notAvailable: 'Not available',
    writeDisabledReason: {
      loading: 'Checking permissions…',
      readOnly: 'Unavailable — your subscription is read-only.',
      unknown: 'Unavailable — we could not check your subscription.',
      forbidden: 'You do not have permission to do this.',
    },
  },
  qr: {
    title: 'Read the receipt QR',
    hint: 'Point the camera at the code on the ticket.',
    unsupported: 'This browser cannot read codes. Type the details by hand.',
    noCamera: 'The camera could not be opened. Allow access, or type the details by hand.',
  },
  promoters: {
    title: 'Promoter commission',
    lead: 'What the business pays whoever brings the loans in.',
    houseRate: 'Business commission',
    houseRateHint: "Points of the loan's rate. Left empty, every promoter is agreed individually.",
    frozenNote: 'The commission is frozen onto each loan at disbursement. Changing this figure only affects new loans.',
    saved: 'Commission saved.',
    saveFailed: 'The commission could not be saved.',
    none: 'No promoter',
    pick: 'Promoter',
    pickHint: 'Who brought this loan in. Their commission is frozen at disbursement.',
    rateFor: 'They would get {points} pts',
    overrideRate: 'Commission for this loan',
    exceedsRate: "That commission exceeds the loan's rate ({rate} pts). Set a smaller one, or disburse without a promoter.",
    fromLoan: 'from this loan',
    fromPromoter: 'their own rate',
    fromHouse: 'from the business',
    notConfigured: 'No commission configured',
  },
  permissions: {
    title: "{name}'s permissions",
    lead: 'Their role decides by default. Adjust it person by person here, without inventing a role for one of them.',
    open: 'Permissions',
    inherit: 'Follow their role',
    allow: 'Allow',
    deny: 'Deny',
    fromRole: 'Their role carries it',
    saved: 'Permissions saved.',
    saveFailed: 'The permissions could not be saved.',
    loadFailed: 'The permissions could not be loaded.',
  },
  pwa: {
    offlineReady: 'Ready to work offline.',
    updateAvailable: 'A new version is available.',
    install: 'Install the app',
    stepsLead: 'Your browser will not let us install it in one tap, but you can do it from its own menu:',
    stepsWhy: 'Installed it opens full screen, starts faster and keeps working where there is no signal.',
    steps: {
      android: [
        'Tap the three dots ⋮ at the top right.',
        'Choose "Add to home screen" or "Install app".',
        'Confirm with "Install".',
      ],
      ios: [
        'Tap the Share button, the square with the arrow pointing up.',
        'Scroll down and choose "Add to Home Screen".',
        'Confirm with "Add".',
      ],
      desktop: [
        'Look for the install icon in the address bar, on the right.',
        'If it is not there, open the browser menu and choose "Install".',
        'Confirm with "Install".',
      ],
    },
    updateWhy: 'Update now. Collecting on an old version can apply rules that have already changed.',
    update: 'Update',
  },
  forbidden: {
    title: 'No access',
    message:
      'Your account has no permission to view this section. Ask your administrator if you think this is a mistake.',
  },
  roles: {
    title: 'Roles',
    create: 'New role',
    name: 'Name',
    system: 'System',
    unscoped: 'Unscoped',
    permissionCount: 'Permissions',
    members: 'Members',
    edit: 'Edit role',
    delete: 'Delete role',
    createTitle: 'New role',
    editTitle: 'Edit role',
    unscopedHint: 'Sees every row in the tenant (not limited to its routes)',
    basicInfo: 'Basic information',
    privileges: 'Privileges',
    permissionGroups: {
      accounting: 'Accounting',
      customers: 'Customers',
      loans: 'Loans',
      loanRequests: 'Loan requests',
      loanTables: 'Tables',
      settings: 'Settings',
      payments: 'Payments',
      routes: 'Routes',
      users: 'Users',
      reports: 'Reports',
      migration: 'Migration',
      general: 'Other',
    },
    permissionActions: {
      accounting: { post: 'Post to the ledger' },
      customers: { view: 'View', manage: 'Manage', photo: 'Attach a photo' },
      loanTables: { manage: 'Create and edit tables' },
      settings: { manage: 'Change the settings' },
      loans: { view: 'View', list: 'List all', create: 'Create', cancel: 'Cancel' },
      loanRequests: { create: 'Create', approve: 'Approve' },
      payments: {
        view: 'View',
        record: 'Record',
        review: 'Review queue',
        waive: 'Waive interest, mora and fees',
      },
      routes: { manage: 'Manage' },
      users: { manage: 'Manage' },
      reports: { view: 'View' },
      migration: { import: 'Import book' },
    },
    deleteConfirm: 'Delete the role “{name}”? This cannot be undone.',
    emptyList: 'No roles yet.',
    created_success: 'Role created.',
    updated_success: 'Role updated.',
    deleted_success: 'Role deleted.',
    actionFailed: 'The operation could not be completed.',
  },
  members: {
    zone: 'Route',
    noZone: 'No route',
    assignZone: 'Assign route',
    zoneHint: 'The route this collector visits. A route carries one collector at a time.',
    zone_assigned_success: 'Route updated.',
    title: 'Team',
    newEmployee: 'New employee',
    name: 'Name',
    firstName: 'First name',
    lastName: 'Last name',
    address: 'Address (optional)',
    contact: 'Contact',
    noContact: 'No contact details',
    password: 'Password',
    phone: 'Phone (optional)',
    employee_created_success: 'Employee created.',
    email: 'Email',
    role: 'Role',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    joined: 'Joined',
    deactivate: 'Deactivate',
    reactivate: 'Reactivate',
    changeRole: 'Change role',
    role_assigned_success: 'Role updated.',
    emptyList: 'No members yet.',
    deactivated_success: 'Member deactivated.',
    reactivated_success: 'Member reactivated.',
    actionFailed: 'The operation could not be completed.',
    roles: {
      Admin: 'Admin',
      Cobrador: 'Collector',
    },
  },
  routes: {
    title: 'Routes',
    create: 'Create route',
    edit: 'Edit route',
    viewDetail: 'View route customers',
    name: 'Name',
    collector: 'Collector',
    unassigned: 'Unassigned',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    activeLabel: 'Route active',
    customers: 'Customers',
    created: 'Created',
    emptyList: 'No routes yet.',
    created_success: 'Route created.',
    updated_success: 'Route updated.',
    saved_success: 'Visit list saved.',
    actionFailed: 'The operation could not be completed.',
    visitOrderTitle: 'Visit order',
    visitOrderHint:
      'The list order is the order in which the collector visits each customer. Save to apply your changes.',
    emptyStops: 'This route has no customers yet.',
    addCustomer: 'Add customer',
    addCustomerHint: 'Search for somebody already on another route to bring them to this one.',
    searchPlaceholder: 'Search by name, code or phone',
    unzonedTitle: 'Customers with no route',
    unzonedHint:
      'They are on no active route, so no collector can see them. Add them to this route and save.',
    unzonedTruncated: 'Showing {shown} of {total}. Save and the rest will appear.',
    addAllUnzoned: 'Add all {count}',
    unzonedWarning:
      '1 customer is on no route: no collector can see them. Open a route to place them. | {count} customers are on no route: no collector can see them. Open a route to place them.',
    add: 'Add to route',
    remove: 'Remove from route',
    moveUp: 'Move up',
    moveDown: 'Move down',
  },
}
